import React from "react";
import cn from "classnames";

import "./index.scss";
import styles from "./style.module.scss";

const Button = ({ text, onClick, classnames, disabled }) => {
  return (
    <button
      onClick={onClick}
      className={cn(classnames, styles.button, disabled && styles.disabled)}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
